import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

export const CountUp = ({ value }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const nums = value.match(/\d+(?:\.\d+)?/g) || [];
  const m = nums.length === 1 ? value.match(/^(.*?)(\d+(?:\.\d+)?)(.*)$/) : null;
  const [n, setN] = useState(m ? 0 : null);
  useEffect(() => {
    if (!m || !inView) return undefined;
    const target = parseFloat(m[2]);
    const c = animate(0, target, { duration: 1.8, ease: [0.22, 1, 0.36, 1], onUpdate: setN });
    return () => c.stop();
  }, [inView]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!m) return <span ref={ref}>{value}</span>;
  const dec = (m[2].split(".")[1] || "").length;
  return (
    <span ref={ref} className="tabular-nums">
      {m[1]}{n.toFixed(dec)}{m[3]}
    </span>
  );
};
